import { ComponentProps } from 'react';

import { cn } from 'src/lib/utils';

export default function CustomModalBody({
  className,
  ...props
}: ComponentProps<'div'>) {
  return (
    <div
      data-slot="dialog-body"
      className={cn('tw:min-h-0 tw:flex-auto tw:px-4 tw:py-2', className)}
      {...props}
    />
  );
}
